import { Collapse, Divider, Flex } from 'antd';
import styled from 'styled-components';

import { utils } from '@desygner/ui-common-components';

type StyleCollapseProps = {
  isMobile: boolean;
};

export const StyledCollapse = styled(Collapse)`
  ${({ theme }) => `
    background-color: ${theme.Color.Neutrals.Paper};
    width: 100%;
    & .ant-collapse-item > .ant-collapse-header,
    .ant-collapse-content > .ant-collapse-content-box {
      padding: 0;
    }
    border-radius: 0;
  `}
`;

export const StyledCollapseDivider = styled(Divider)<StyleCollapseProps>`
  ${({ theme, isMobile }) => `
    display: ${isMobile ? 'none' : 'flex'};
    height: 1px;
    justify-content: center;
    align-items: center;
    align-self: stretch;
    margin: ${utils.rem(theme.Spacing.Size.Small)} 0px;
    border-color: ${theme.Color.Neutrals.Border};
  `};
`;

export const StyledCollapseHeader = styled(Flex)<StyleCollapseProps>`
  justify-content: ${({ isMobile }) => (isMobile ? 'space-between' : 'flex-start')};
`;

export const StyledCollapseItem = styled(Flex)`
  ${({ theme }) => `
    flex-direction: column;
    gap: ${utils.rem(theme.Spacing.Size.Small)}
  `}
`;

export const StyledCollapseItemText = styled(Flex)`
  ${({ theme }) => `
    cursor: default;
    & span {
      height: ${utils.rem(theme.Spacing.Size.Medium)};
    };
  `}
`;

export const StyledCollapseItemLink = styled(Flex)`
  ${({ theme }) => `
    & a:hover {
      i svg {
        color: ${theme.Color.Brand.Primary};
        fill: ${theme.Color.Brand.Primary};
      }
    }
  `}
`;
